export class VariantOption {
  variantId: string;

  optionId: string;

  value: string;
}
